<template>
   <div class="scrollableY">
        <div class="container has-text-white" >
            <div  class="top20">&nbsp;</div>
            <div v-show="notFound">
                <div class="is-size-3 has-text-white">No Bundle Was Found for that link</div>
            </div>
           
            
    
            <div v-if="loaded && !notA">
    
                <div v-show="!notFound" class="has-text-centered">
                    <div v-show="!isPush"><div class="is-size-3 has-text-white"><b>{{fName}} {{lName}}</b></div></div>
                    <div class="is-size-3">shared this <b class="has-text-coolGreen">bundle</b> with you</div>
                    <!-- <div v-show="createDate" class="top5">On: <b>{{az.dateConvert(createDate)}}</b></div> -->
                    <!-- <div class="top20">You may import full bundles using the IMPORT button below, or individual miimus from each miimu's ellipsis button.</div> -->
                 </div>
                 <div v-if="upd" class="bottom20">
                     <br>
                     <div class="is-size-4 has-text-dark has-background-light yellowBorderTitle">The following updates have been made.</div>
                     <div>Please review each bundle and its contents. Selected links across all of these bundles will be imported when you click the IMPORT button.</div>
                </div>
                 <div v-if="isPush" class="bottom20">
                     <br>
                     <div class="is-size-4 has-text-dark has-background-light yellowBorderTitle">You have added the cards to bundles since you shared them. You may choose which cards to include in this update.  Cards you do not include will be ignored and 'updates pending' flags  (<i class="fas fa-cloud-upload-alt is-size-6 top-5 red"></i>) will be cleared. </div>
                </div>
                <br>
               
                <div v-if="!upd && !notFound" class="shareBundleFrame">
                    <bundle-shared class="holder top15" v-bind:info="bundle[0]" v-bind:listIndex="1" :shareId="shareId" ref="bundleShared"></bundle-shared>
                </div>
                
                <div class="top20 is-size-5 has-text-centered"><b>Click below to import this bundle</b> <br>
                    <button v-show="!notFound" id="mainButt" class="button is-coolGreen top10 right10" :disabled="shareId == ''" @click="importIt">{{actionLabel}}</button>
                </div>
                

               <!--  <div class="top20 is-size-5"><b>Not a Miimu user yet?</b> <br>Miimu is a fun way to capture, bundle, and share your online content. 
                Create your free account today!
                </div>
                <button  class="button is-coolGreen top10 right10"  @click="$router.push('/pricing')">REGISTER</button> -->


            </div>
    
            <div v-if="loaded && notA">
                <div class="is-size-4">You have not been granted permission to view this information.</div>
            </div>
        </div>
   </div>
</template>


<script>

import { AZEventBus } from '../components/AZEventBus'
import BundleShared from '../components/BundleShared'
import BundleSharedUpdate from '../components/BundleSharedUpdate'

export default{

    props: {
        upd: {
            type: Boolean,
            default: false
        },
        isPush: {
            type: Boolean,
            default: false
        },
        theBundle: {
            type: Array,
            default: null
        },
        updateId: {
            type: String,
            default: null
        },
        notId: {
            type: Number,
            default: null
        },
        setNotTo3: {
            type: Boolean,
            default: false
        }
        
    },

    data: function(){
        return {
            inited: false,
            notFound: false,
            fName: '',
            lName: '',
            bundle: [],
            az: az,
            createDate: '',
            shareId: null,
            actionLabel: 'IMPORT',
            cards: [],
            toIgnore: [],
            dirtyCards: [],
            showBundleCards: true,
            forImportSelectedBundleId: null,
            forImportSelectedOrigBundleId: null,
            downloadedCards: [],
            notA: false,
            loaded: false,
            importAcl: null,
            cardsInBundlesNotInAccount: [],
            altBundle: {}
        }
    },

    components: {BundleShared, BundleSharedUpdate},

    mounted: function(){

        var self = this;

        

        if(this.upd){
            this.actionLabel = 'IMPORT' 
        } else if(this.isPush){
            this.actionLabel = 'PUBLISH'
        }

        function w(d){
           
            //az.addRemSpinner(false, 'class', 'holder')
            self.loaded = true

          

            if(d.response == 'not found'){
                self.notFound = true
            } else {

                self.fName = d.response.fName;
                self.lName = d.response.lName;
                self.createDate = d.response.createDate;
                
                if(self.upd){
                      
                    //build a bundle based on where update cards fall in current user's bundles using origId
                    //get list of bundles ids in update
                    let bList = []
                    let bList2 = [] //bundles where isPushFromImport == true
                    let flaggedBundles = []
                    let roots = []
                    

                    self.downloadedCards = d.cards

                    let idsInAppBundles = [];
                     
                    self.$root.app.bundles.forEach(n => {
                        idsInAppBundles.push(n.origId)
                    })        
                    
                    

                    d.cards.forEach(e => {
                        if(!bList.includes(e.id_BUNDLES))
                            bList.push(e.id_BUNDLES)

                        if(!bList2.includes(e.origin_ID_BUNDLES))
                            bList2.push(e.origin_ID_BUNDLES)

                        if(!idsInAppBundles.includes(e.id_BUNDLES)){
                            self.cardsInBundlesNotInAccount.push(e)
                        }
                    })

                    if(self.cardsInBundlesNotInAccount.length > 0){
                        self.altBundle = {
                            children: [],
                            listName: 'Uncategorized',
                            items: self.cardsInBundlesNotInAccount,
                        }
                    }

                    self.cardsInBundlesNotInAccount.forEach(e => {
                        self.unInclude(e.id)
                    })



                    //make array of bundles in update
                    self.$root.app.bundles.forEach(e => {
                        if(e.origId == undefined || e.origId == '') e.origId = e.id
                        if(bList.includes(e.origId)){
                            if(e.branch.length == 1){
                                roots.push(e)
                            }

                            if(e.items2 == undefined)
                                e.items2 = []

                            self.downloadedCards.forEach(c => {
                                if(c.id_BUNDLES == e.origId){
                                    c.importedBundleId = e.id
                                    c.ignore = false
                                    e.items2.push(c)
                                }
                            })

                            e.items = e.items2
                            flaggedBundles.push(e)
                        }
                    })

                    //make array of bundles in update
                    self.$root.app.bundles.forEach(e => {
                        if(e.origId == undefined || e.origId == '') e.origId = e.id
                        if(bList2.includes(e.origId)){
                            if(e.branch.length == 1){
                                roots.push(e)
                            }

                            if(e.items2 == undefined)
                                e.items2 = []

                            self.downloadedCards.forEach(c => {
                                if(c.origin_ID_BUNDLES == e.origId){
                                    c.importedBundleId = e.id
                                    c.ignore = false
                                    e.items2.push(c)
                                }
                            })

                            e.items = e.items2
                            flaggedBundles.push(e)
                        }
                    })

                
                    
                    //build tree

                    flaggedBundles.sort((a,b) => {
                        return a.branch.length - b.branch.length
                    })

                   
                    let a = {
                        children: [],
                        listName: 'In Imported Bundles',
                        items: []    
                    }
                    a.children = flaggedBundles

                   
                    self.bundle = [a]

                    if(self.bundle[0].children[0]){
                        setTimeout(function(){
                            self.$refs.bundleSharedUpdate.data.items = self.bundle[0].children[0].items
                            self.$refs.bundleSharedUpdate.$refs.subBundle[0].selectedForImport = true;
                            self.forImportSelectedBundleId = self.bundle[0].children[0].id
                            self.forImportSelectedOrigBundleId = self.bundle[0].children[0].origId
                        }, 200)
                    }

                    let n = self.$root.app.nots.find(e => {
                        return e.id == self.notId
                    })
                    n.markAsRead = 1


                } else {
                    if(d.response == 'Not Authorized'){
                        self.notA = true
                        return
                    }

                    if(d.response.id_cog == self.$root.app.userAttrs.sub) {
                        self.$root.app.showModalOK({message: "You may not import a share you created yourself."})
                        self.$router.push('/bundles')
                        return
                    }

                    self.shareId = d.response.id
                    self.bundle = JSON.parse(d.response.dataBlob)

                    self.importAcl = d.response.acl
                }
            }
        }

        function n(){
            az.addRemSpinner(false, 'class', 'holder')
            self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support'})
        }

        function init(){
            if(self.upd){
                self.$root.app.apiClient.get('subs/data/getUpdateToBundle/' + self.updateId + '/' + self.notId + "_" + self.setNotTo3, {}, w, n)

            } else if(self.isPush){
                //az.addRemSpinner(false, 'class', 'holder')`
                self.bundle = self.theBundle
                self.getDirtyCards(self.theBundle[0].id)
                
            } else {
                //az.addRemSpinner(false, 'class', 'holder')
                let notId = self.$route.query.notid ? `_${self.$route.query.notid}` : ''
                self.$root.app.apiClient.get('open/confirm/share/' + self.$route.query.s + notId, {}, w, n)
            }
        }

        if(self.$root.app.doneFederating){
            self.inited = true;
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });

    },

    methods: {
        importIt: function(){

            var self = this

            if(this.isPush){

                  function w(data){
                        az.addRemSpinner(false, 'id', 'mainButt')
                        if(data.response == 'ok'){

                            var b = self.$root.app.bundles.find(e => {
                                return e.id == self.bundle[0].id
                            })
                            b.dirt = 0;
                            self.$router.push('/bundles')

                        } else {

                        }
                    }

                    function n(){
                        az.addRemSpinner(false, 'id', 'mainButt')
                    }

                    az.addRemSpinner(true, 'id', 'mainButt')

                    //recurse through bundle children add all bundle ids to bundlesInUpdate array

                    var bundlesInUpdate = [self.theBundle[0].id]

                    function addIds(arr){
                        for(var n=0; n < arr.length; n++){
                            bundlesInUpdate.push(arr[n].id)
                            if(arr[n].children.length > 0){
                                addIds(arr[n].children)
                            }
                        }
                    }

                    if(self.theBundle[0].children.length > 0)
                        addIds(self.theBundle[0].children)
                    
                    var toIgnoreArrs = {}

                    bundlesInUpdate.forEach(e => {
                        toIgnoreArrs["b" + e] = []
                        this.toIgnore.forEach(i => {
                            if(e == i.b){
                                toIgnoreArrs["b" + e].push(i.id)
                            }
                        })
                    })

                   Object.keys(toIgnoreArrs).forEach(e => {
                       if(toIgnoreArrs[e].length == 0)
                         delete toIgnoreArrs[e]
                   })                 

                
                  this.$root.app.apiClient.post('subs/data/pushupdates' , {id_BUNDLES: this.bundle[0].id, bundlesInUpdate: bundlesInUpdate, ignoreArrs: toIgnoreArrs}, w, n);

                } else if (this.upd) {

                    function w(data){
                        if(data.response == 'ok'){
                            let n = self.$root.app.nots.find(e => {
                                return e.id == self.notId
                            })
                            n.markAsRead = 2

                            self.$router.push('/bundles');
                        }
                    }

                    function n(){
                        az.addRemSpinner(false, 'id', 'mainButt')
                    }
    
                    //send API call to process imported and ignored cards
                    this.$root.app.apiClient.post('subs/data/importupdate', {cards: self.downloadedCards, updateId: self.updateId, notId: self.notId, setNotTo3: self.setNotTo3}, w, n);
                    
                    
                } else {  //import share
                    if(!this.$root.app.isAuth){
                        this.$root.app.showModalLogin()
                        return
                    }

                    let notId = this.$route.query.s.split('_')[1] || null
                    this.$root.app.doShowModal('ModalImport', {bundle: this.bundle, shareId: this.shareId, importAcl: parseInt(this.importAcl), notId: parseInt(notId)})
                }

        },

        getDirtyCards: function(id){

            
                var self = this;
                //az.addRemSpinner(true, 'id', 'spin')

                function w(data){
                    
                   az.addRemSpinner(false, 'class', 'holder')
                   self.showBundleCards = true
                   self.loaded = true

                    if(data.dirtyCards.length){
                        self.dirtyCards = data.dirtyCards;

                       

                       /*  self.$refs.bundleShared.conts.items = self.$refs.bundleShared.conts.items.filter(e => {
                            return self.dirtyCards.includes(e.id)
                        }) */

                        self.bundle[0].items = self.bundle[0].items.filter(e => {
                            return self.dirtyCards.includes(e.id)
                        }) 

                    
                    } else {
                        self.bundle[0].items = []
                    }

                }

                function n(){
                    az.addRemSpinner(false, 'class', 'holder')
                }

                az.addRemSpinner(true, 'class', 'holder')
                self.showBundleCards = false
                this.$root.app.apiClient.get('subs/data/originatordirtycards/' + id, {}, w, n);
        },

        closeAllMenus: function(){
            AZEventBus.$emit('closeAllMenus', {})
        },
        unInclude: function(id){

            if(this.upd){
                this.toIgnore.push({b: this.forImportSelectedBundleId, origB: this.forImportSelectedOrigBundleId, id: id})
                let c = this.downloadedCards.find(e => {
                    return e.id == id
                })

                c.ignore = true
            } else {
                this.toIgnore.push({b: this.$refs.bundleShared.conts.id, id: id})
            }
            
        },
        include: function(id){
            var bId = null
            if(this.upd){
                bId = this.forImportSelectedBundleId

                let c = this.downloadedCards.find(e => {
                    return e.id == id
                })

                c.ignore = false
            } else {
                bId = this.$refs.bundleShared.conts.id
                
            }

            for(var i=0; i < this.toIgnore.length; i++){
                if(this.toIgnore[i].id == id && this.toIgnore[i].b == bId){
                    this.toIgnore.splice(i, 1)
                    break
                }
            }
            
            
        }
    }

}

</script>